/* Реєстр текстів: спільне (меню, кнопки) і головна. Формат поля —
   [ключ, підпис в адмінці, текст за замовчуванням]. Див. siteTexts.js. */

export const PAGES_HOME = [
  { id: 'common', label: 'Спільне: меню й кнопки', path: '/', sections: [
    { id: 'common.nav', label: 'Меню вгорі та футер', fields: [
      ['tagline', 'Підпис біля логотипа', '№1 автоматична торгівля\nакціями по алгоритмам'],
      ['home', 'Пункт «Головна» (футер)', 'Головна'],
      ['returns', 'Пункт «Дохідність»', 'Дохідність'],
      ['guarantees', 'Пункт «Гарантії»', 'Гарантії'],
      ['advantages', 'Пункт «Переваги»', 'Переваги'],
      ['pricing', 'Пункт «Ціни»', 'Ціни'],
      ['how_to_start', 'Пункт «Як почати»', 'Як почати?'],
      ['contacts', 'Пункт «Контакти»', 'Контакти'],
      ['login', 'Кнопка входу в меню', 'Реєстрація/Вхід'],
      ['demo', 'Кнопка демо-доступу', 'Демонстраційний доступ'],
      ['menu_note', 'Текст унизу мобільного меню', 'Автоматизована торгівля на фондовому ринку США через рахунок IBKR'],
      ['footer_login', 'Кнопка входу у футері', 'Вхід в акаунт'],
    ] },
    { id: 'common.buttons', label: 'Кнопки в блоках сторінок', fields: [
      ['demo', 'Демо-доступ', 'Демонстраційний доступ'],
      ['register', 'Реєстрація', 'Реєстрація'],
    ] },
    { id: 'common.calc', label: 'Калькулятор (форма — однакова на Головній і «Дохідності»)', fields: [
      ['params_title', 'Заголовок форми', 'Параметри розрахунку'],
      ['params_sub', 'Підзаголовок форми', 'Оберіть або введіть суму інвестиції'],
      ['start_label', 'Дата початку', 'Дата початку торгів'],
      ['end_label', 'Дата завершення', 'Дата завершення торгів (не раніше 1 року від початку)'],
      ['amount_label', 'Сума', 'Сума інвестиції ($)'],
      ['reinvest_label', 'Галочка реінвестування', 'Реінвестувати прибуток'],
      ['reinvest_hint', 'Пояснення до галочки', '— прибуток автоматично реінвестується в стратегію'],
      ['fee_deposit', 'Галочка: комісія на ввід', 'Комісія на ввід коштів'],
      ['fee_taxes', 'Галочка: податки', 'Податки'],
      ['fee_trading', 'Галочка: комісія Trading', 'Комісія Trading.com.ua'],
      ['button', 'Кнопка', 'Розрахувати за історичними даними'],
      ['button_loading', 'Кнопка під час розрахунку', 'Розраховуємо…'],
      ['result_title', 'Заголовок результату', 'Результат інвестування'],
      ['disclaimer', 'Застереження під результатом', 'Розрахунки базуються на історичних даних і не гарантують майбутньої прибутковості. Проконсультуйтеся з фінансовим консультантом.'],
    ] },
  ] },

  { id: 'home', label: 'Головна', path: '/', sections: [
    { id: 'home.hero', label: 'Перший екран', fields: [
      ['title', 'Заголовок (*слово* — блакитне виділення)', '*Автоматична* торгівля акціями по алгоритмам із доходністю'],
      ['title_frame', 'Кінець заголовка в зеленій рамці', '{returns_claim} річних'],
      ['bullet1', 'Пункт 1', 'Ваші акції і кошти зберігаються на [InteractiveBrokers.co.uk](https://www.interactivebrokers.co.uk)'],
      ['bullet2', 'Пункт 2', 'Автоматично ведемо ними алгоритмічну торгівлю'],
      ['bullet3', 'Пункт 3', 'Проект розроблений і є частиною компанії [SoftGroup.ua](https://softgroup.ua)'],
      ['float_wallet', 'Плаваюча картка (гаманець)', 'Купуємо лідерів росту та продаємо аутсайдерів 24/7, поки ви займаєтесь своїми справами'],
      ['float_insured', 'Плаваюча картка (страхування)', 'Акції і кошти застраховані на суму до **500.000$**'],
    ] },
    { id: 'home.calc', label: 'Калькулятор: заголовок', fields: [
      ['title', 'Заголовок', 'Розрахуйте прогнозований прибуток'],
      ['subtitle', 'Підзаголовок', 'На історичних минулих данних цін на акції по нашим актуальним алгоритмам. Введіть лише одну цифру, щоб побачити магію алготрейдингу'],
      ['total_label', 'Підпис підсумку', 'Загальна сума через обраний період'],
    ] },
    { id: 'home.vt', label: 'Віртуальні торги', fields: [
      ['title', 'Заголовок', 'Почати безкоштовні віртуальні торги'],
      ['lead', 'Текст', 'Зареєструйтеся, введіть суму — програма автоматично почне торгувати акціями на цю суму. Ви дізнаєтеся скільки могли б отримати без жодного ризику для реальних коштів.'],
      ['note', 'Примітка', 'Дохідність визначається на довгому часовому горизонті. **Раз на три місяці ми будемо надсилати вам звіт про стан портфелю та поточну дохідність** — на пошту або в телеграм, на ваш вибір.'],
      ['form_title', 'Заголовок форми', 'Віртуальні торги'],
      ['amount_label', 'Підпис суми', 'Ввести суму ($)'],
      ['amount_placeholder', 'Підказка в полі суми', 'Або введіть свою суму'],
      ['reinvest', 'Галочка', 'Реінвестувати прибуток'],
      ['button', 'Кнопка', 'Почати віртуальні торги'],
      ['caption', 'Підпис під кнопкою', 'Від сьогодні, по нашим актуальним алгоритмам'],
      // Кнопка веде на реєстрацію (app.*); повідомлення нижче показує вже КАБІНЕТ
      // — лише там відомо, чи є в користувача реальні або віртуальні торги.
      ['ok_title', 'Кабінет, торги запущено: заголовок', 'Віртуальні торги запущено!'],
      ['ok_text', 'Кабінет, торги запущено: текст ({amount} — сума)', 'Ми активували алгоритмічну торгівлю на віртуальну суму **{amount} $** за нашими актуальними стратегіями.'],
      ['ok_note', 'Кабінет, торги запущено: примітка', 'Результати відображаються на сторінці «Мій акаунт».'],
      ['starting', 'Кабінет: поки запускаємо', 'Запускаємо віртуальні торги…'],
      ['real_title', 'Кабінет, є реальні торги: заголовок', 'Віртуальні торги не запущено'],
      ['real_text', 'Кабінет, є реальні торги: текст', 'У вас вже запущені реальні торги, запустити віртуальні торги під час реальних торгів неможливо.'],
      ['again_title', 'Кабінет, вже є віртуальні: заголовок', 'У вас вже запущені віртуальні торги'],
      ['again_text', 'Кабінет, вже є віртуальні: текст ({start} — дата старту, {amount} — сума)', 'Відмінити попередні (з {start}, **{amount} $**) і запустити віртуальні торги по новій від сьогоднішньої дати?'],
      ['again_yes', 'Кабінет, вже є віртуальні: кнопка «так»', 'Так, запустити по новій'],
      ['again_no', 'Кабінет, вже є віртуальні: кнопка «ні»', 'Ні, залишити попередні'],
      ['close', 'Кабінет: кнопка закриття', 'Зрозуміло'],
      ['error', 'Кабінет: помилка запуску', 'Не вдалося запустити віртуальні торги. Спробуйте ще раз на сторінці «Налаштування».'],
    ] },
    { id: 'home.algo', label: 'Як працює наш алгоритм', fields: [
      ['title', 'Заголовок', 'Як працює наш алгоритм'],
      ['lead', 'Текст', "Забудьте про емоції та суб'єктивні прогнози. Система аналізує тисячі акцій у реальному часі, слідуючи за капіталом великих гравців."],
      ['step1_tag', 'Крок 1: мітка', 'Selection'],
      ['step1_title', 'Крок 1: заголовок', 'Сканування'],
      ['step1_text', 'Крок 1: текст', 'Алгоритм щоденно фільтрує фондовий ринок США, обираючи топ-акції з найсильнішою висхідною динамікою. Ми купуємо лише те, що вже зростає.'],
      ['step2_tag', 'Крок 2: мітка', 'Execution'],
      ['step2_title', 'Крок 2: заголовок', 'Автоматичне виконання'],
      ['step2_text', 'Крок 2: текст', "Через API-зв'язок система миттєво відкриває позиції на вашому рахунку Interactive Brokers. Швидкість реакції — частки секунди."],
      ['step3_tag', 'Крок 3: мітка', 'Exit Strategy'],
      ['step3_title', 'Крок 3: заголовок', 'Ребалансування'],
      ['step3_text', 'Крок 3: текст', 'Як тільки акція втрачає темп або починає дешевшати — алгоритм миттєво фіксує прибуток і перекладає кошти в нових лідерів ринку.'],
    ] },
    { id: 'home.compare', label: 'Технологічний захист і таблиця «Людина / Алгоритм»', fields: [
      ['title', 'Заголовок', 'Технологічний захист\nвашого капіталу'],
      ['f1_title', 'Пункт 1: заголовок', 'Автоматичний Stop-Loss'],
      ['f1_text', 'Пункт 1: текст', 'Система автоматично закриває позицію при найменшому відхиленні від заданих параметрів безпеки.'],
      ['f2_title', 'Пункт 2: заголовок', 'Тільки High-Liquidity активи'],
      ['f2_text', 'Пункт 2: текст', 'Алгоритм працює виключно з акціями великих капіталізованих компаній (Blue Chips). Ніякого ризикового «сміття» чи неліквідних паперів.'],
      ['f3_title', 'Пункт 3: заголовок', 'Multi-Account Management'],
      ['f3_text', 'Пункт 3: текст', 'Керуйте декількома рахунками Interactive Brokers з одного інтерфейсу. Ідеальне рішення для розподілу капіталу або управління бізнесом.'],
      ['col_feature', 'Таблиця: перша колонка', 'Характеристика'],
      ['col_human', 'Таблиця: колонка людини', 'Людина-трейдер'],
      ['col_algo', 'Таблиця: колонка алгоритму', 'Наш Алгоритм'],
      ['r1_feature', 'Рядок 1: що порівнюємо', 'Швидкість реакції'],
      ['r1_human', 'Рядок 1: людина', 'Хвилини/Години'],
      ['r1_algo', 'Рядок 1: алгоритм', 'Мілісекунди'],
      ['r2_feature', 'Рядок 2: що порівнюємо', 'Емоційний фактор'],
      ['r2_human', 'Рядок 2: людина', 'Страх, жадібність, надія'],
      ['r2_algo', 'Рядок 2: алгоритм', '0% (суха математика)'],
      ['r3_feature', 'Рядок 3: що порівнюємо', 'Обсяг даних'],
      ['r3_human', 'Рядок 3: людина', '5-10 компаній'],
      ['r3_algo', 'Рядок 3: алгоритм', 'Весь ринок (S&P 500 / Russell 2000)'],
      ['r4_feature', 'Рядок 4: що порівнюємо', 'Час роботи'],
      ['r4_human', 'Рядок 4: людина', '4-6 годин на день'],
      ['r4_algo', 'Рядок 4: алгоритм', '24/7 моніторинг'],
    ] },
    { id: 'home.control', label: 'Ваш капітал під повним контролем', fields: [
      ['title', 'Заголовок', 'Ваш капітал під повним контролем'],
      ['subtitle', 'Підзаголовок', 'Інтерфейсу для моніторингу вашого портфеля в реальному часі'],
      ['ops_title', 'Заголовок списку операцій', 'Останні операції'],
      ['ops_badge', 'Мітка списку', 'Оновлюється'],
    ] },
    { id: 'home.ibkr', label: 'Ваш капітал на платформі IBKR', fields: [
      ['title', 'Заголовок', 'Ваш капітал на платформі\nброкера IBKR №1 у світі'],
      ['subtitle', 'Підзаголовок', 'Ми не приймаємо ваші кошти на свої рахунки. Ви відкриваєте власний акаунт у найбільшого американського брокера.'],
      ['diagram_title', 'Заголовок схеми', 'Ми не приймаємо ваші\nкошти на свої рахунки'],
      ['diagram_note', 'Текст під схемою', 'Ви відкриваєте власний акаунт у найбільшого американського брокера, а наш алгоритм лише допомагає йому працювати ефективніше.'],
      ['c1_title', 'Картка 1: заголовок', 'Публічна компанія зі США'],
      ['c1_text', 'Картка 1: текст', '**Interactive Brokers (NASDAQ: IBKR)** — це фінансовий гігант з капіталом **понад $12 млрд**, діяльність якого суворо регулюється комісіями SEC та FINRA.'],
      ['c2_title', 'Картка 2: заголовок', 'Страхування активів SIPC'],
      ['c2_text', 'Картка 2: текст', 'Ваші цінні папери та готівкові кошти захищені державною корпорацією страхування інвесторів на суму **до $500,000**. Це стандарт безпеки американського ринку.'],
      ['c3_title', 'Картка 3: заголовок', 'Безпечне підключення через API'],
      ['c3_text', 'Картка 3: текст', 'Ви надаєте алгоритму доступ виключно до виконання торгових операцій. Ми не маємо технічної можливості вивести ваші кошти або переказати їх на інший рахунок.'],
      ['c4_title', 'Картка 4: заголовок', 'Найнижчі комісії для алготрейдингу'],
      ['c4_text', 'Картка 4: текст', 'Завдяки прямому доступу до бірж (Direct Market Access), ваші витрати на транзакції мінімальні, що дозволяє алгоритму закривати сотні прибуткових угод без зайвих втрат.'],
    ] },
    { id: 'home.cases', label: 'Кейси: заклик праворуч', fields: [
      ['cta_title', 'Заклик', 'Хочете стати наступним\nуспішним кейсом?'],
    ] },
    { id: 'home.faq', label: 'FAQ: заголовок', fields: [
      ['badge', 'Мітка', 'FAQ'],
      ['title', 'Заголовок (*слово* — виділення)', 'Розвіюємо сумніви: Все, що ви хотіли запитати про *Алготрейдинг*'],
    ] },
    { id: 'home.cta', label: 'Заклик унизу (ракета)', fields: [
      ['title', 'Заголовок', 'Почніть заробляти на технологічній перевазі вже сьогодні'],
      ['subtitle', 'Текст', 'Приєднуйтесь до спільноти розумних інвесторів. Налаштування алгоритму на вашому рахунку Interactive Brokers **займає менше 15 хвилин**.'],
      ['button', 'Кнопка', 'Запустити Алготрейдинг'],
      ['perk1', 'Перевага 1', 'Без передоплат'],
      ['perk2', 'Перевага 2', 'Без кредитних карток'],
      ['perk3', 'Перевага 3', 'Тільки ваш IBKR'],
    ] },
  ] },
];
